/* Great Lakes Lavender Farm Simulator — B210 no-op write filter.
   Several older modules re-apply identical attributes and classes every frame; each write
   wakes the other modules' observers and they keep re-triggering each other. Inside the
   simulator only, writes that would not change anything are skipped. Theme elements are untouched. */
(()=>{'use strict';
  if(window.__gllfNoopFilterB210)return;window.__gllfNoopFilterB210=true;
  const inSim=el=>{try{return !!el.closest&&!!el.closest('.lfg[data-section]')}catch{return false}};
  const LIVE=new Set(['src','href','srcset','data','poster','value','checked','selected','open']);
  const setAttr=Element.prototype.setAttribute;
  Element.prototype.setAttribute=function(name,value){
    const n=String(name).toLowerCase();
    if(!LIVE.has(n)&&this.getAttribute(name)===String(value)&&inSim(this))return;
    return setAttr.call(this,name,value);
  };
  const tl=DOMTokenList.prototype,add=tl.add,remove=tl.remove,toggle=tl.toggle;
  tl.add=function(...t){for(const x of t)if(!this.contains(x))return add.apply(this,t)};
  tl.remove=function(...t){for(const x of t)if(this.contains(x))return remove.apply(this,t)};
  tl.toggle=function(t,force){if(force===true&&this.contains(t))return true;if(force===false&&!this.contains(t))return false;return toggle.apply(this,arguments)};
  const wrapProp=(proto,prop)=>{const d=Object.getOwnPropertyDescriptor(proto,prop);if(!d||!d.set||!d.get)return;
    Object.defineProperty(proto,prop,{configurable:true,enumerable:d.enumerable,get:d.get,set(v){if(d.get.call(this)===v&&inSim(this))return;d.set.call(this,v)}})};
  wrapProp(HTMLAnchorElement.prototype,'target');wrapProp(HTMLAnchorElement.prototype,'rel');
  wrapProp(Element.prototype,'className');wrapProp(HTMLElement.prototype,'title');wrapProp(HTMLElement.prototype,'tabIndex');wrapProp(HTMLElement.prototype,'hidden');
})();
